import type { MPLOffer, MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import { isMplOffer, isMplPreApprovalOffer } from 'shared/lib';
import type { TOffer } from 'shared/types/TRankingService';

export const getAnalyticsProductParams = (offer: TOffer | MPLOffer | MPLPreApprovalOffer) => {
  if (isMplOffer(offer)) {
    return {
      offerType: 'MPL',
      productName: 'Маркетплейс',
      productId: '',
      organizationId: offer.organizationId,
      organizationName: offer.organizationName,
      offerIndex: offer.order,
    };
  }

  if (isMplPreApprovalOffer(offer)) {
    return {
      offerType: 'Preapprove',
      productName: offer.productName,
      productId: offer.productId,
      organizationId: offer.organizationId,
      organizationName: offer.organizationName,
      offerIndex: offer.order,
    };
  }

  return {
    offerType: 'Lidgen',
    productName: offer.productName,
    productId: offer.id,
    organizationId: offer.bankId,
    organizationName: offer.bankName,
    offerIndex: offer.order,
  };
};
